import {
  USERS_PAGINATED_FETCH_STARTED,
  USERS_PAGINATED_FETCH_SUCCEEDED,
  USERS_PAGINATED_FETCH_FAILED,
  USERS_PAGINATED_CHANGE_PAGE,
  USERS_PAGINATED_CHANGE_ITEMS_PER_PAGE,
  USERS_PAGINATED_CHANGE_ORDER,
  USERS_PAGINATED_CHANGE_ORDER_BY,
  USERS_PAGINATED_CHANGE_ORDER_AND_ORDER_BY,
  USERS_PAGINATED_SET_FILTER,
  USERS_PAGINATED_CLEAR,
  USERS_PAGINATED_TOGGLE_INACTIVE
} from '#action/types';
import { getUsersWithRootProjects } from '#component/user/dashboard/helper';
import { requestStatuses as statuses } from '#helper';

const defaultState = {
  status: statuses.idle,
  userDevicesStatus: statuses.idle,
  users: [],
  error: null,
  page: 1,
  itemsPerPage: 50,
  order: 'asc',
  orderBy: 'firstName',
  pages: 0,
  filter: null,
  filterBy: ['fullName', 'project', 'email'],
  hideDisabledUsers: false
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case USERS_PAGINATED_FETCH_STARTED:
      return { ...state, status: statuses.loading, error: null };
    case USERS_PAGINATED_FETCH_SUCCEEDED:
      const { users, projects, deviceCount } = action.payload;

      return {
        ...state,
        status: statuses.succeeded,
        users: getUsersWithRootProjects(users, projects, deviceCount),
        pages: Math.ceil(action.totalCount / state.itemsPerPage),
        totalCount: action.totalCount
      };
    case USERS_PAGINATED_FETCH_FAILED:
      return { ...state, status: statuses.failed, users: [], error: action.error };
    case USERS_PAGINATED_CHANGE_PAGE:
      return { ...state, page: action.payload };
    case USERS_PAGINATED_CHANGE_ITEMS_PER_PAGE:
      return { ...state, itemsPerPage: action.payload };
    case USERS_PAGINATED_CHANGE_ORDER:
      return { ...state, order: action.payload };
    case USERS_PAGINATED_CHANGE_ORDER_BY:
      return { ...state, orderBy: action.payload };
    case USERS_PAGINATED_CHANGE_ORDER_AND_ORDER_BY:
      return { ...state, order: action.payload.order, orderBy: action.payload.orderBy };
    case USERS_PAGINATED_SET_FILTER:
      return { ...state, filter: action.payload };
    case USERS_PAGINATED_TOGGLE_INACTIVE:
      return { ...state, hideDisabledUsers: action.payload };
    case USERS_PAGINATED_CLEAR:
      return defaultState;
    default:
      return state;
  }
};
